import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/layoutActions";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import redirector from "../../../util/redirector";

import DoelgroepPageHelper from "./DoelgroepPageHelper";
import DoelgroepForm from "./DoelgroepForm";
import * as nieuweSportclubModelsActions from "../../../actions/nieuweSportclubModelsActions";
import mergeDeep from "../../../util/mergeDeep.js";
import { orderByPropertyName } from "../../../util/orderBy.js";

class DoelgroepPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state =
        {
            model: {
                doelgroepen: []
            }
        };

        this.pageHelper = new DoelgroepPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    componentWillUnmount = () => {
        let model = mergeDeep({}, this.state.model);
        this.props.updateModel(model);
    };

    handleOnGoToNext = () => this.pageHelper.goToNext();
    handleOnGoToPrev = () => this.pageHelper.goToPrev();
    handleOnChange = (event) => this.pageHelper.change(event);

    render() {
        const props = this.props;
        const doelgroepen = props.doelgroepen;
        const state = this.state;
        const model = state.model;

        return (
            <DoelgroepForm
                goToNext={this.handleOnGoToNext}
                goToPrev={this.handleOnGoToPrev}
                onChange={this.handleOnChange}
                doelgroepen={doelgroepen}
                model={model}
            />
        );
    }
}

DoelgroepPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        storeModel: state.nieuweSportclubModels.doelgroep,
        doelgroepen: orderByPropertyName(state.referentie.doelgroepen, "order")
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadNieuweSportclubDoelgroepPageLayout, dispatch),
        updateModel: bindActionCreators(nieuweSportclubModelsActions.doelgroepModelUpdate, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DoelgroepPage);